import React from "react";
import TextInput from "../../../../components/Input/TextInput";
import { SimpleGrid, Text } from "@mantine/core";
import { useEffect } from "react";

const FeesDropdown = ({ form }) => {
  useEffect(() => {
    // add all fees together and set the total fees
    const totalFee =
      (isNaN(parseFloat(form.values.licenseFee)) ? 0 : parseFloat(form.values.licenseFee)) +
      (isNaN(parseFloat(form.values.registrationFee)) ? 0 : parseFloat(form.values.registrationFee)) +
      (isNaN(parseFloat(form.values.titleFee)) ? 0 : parseFloat(form.values.titleFee)) +
      (isNaN(parseFloat(form.values.lienFee)) ? 0 : parseFloat(form.values.lienFee)) +
      (isNaN(parseFloat(form.values.inspectionFee)) ? 0 : parseFloat(form.values.inspectionFee)) +
      (isNaN(parseFloat(form.values.dealerProcessingFee)) ? 0 : parseFloat(form.values.dealerProcessingFee)) +
      (isNaN(parseFloat(form.values.dealerProcessingFeeItemized)) ? 0 : parseFloat(form.values.dealerProcessingFeeItemized)) +
      (isNaN(parseFloat(form.values.freightCharges)) ? 0 : parseFloat(form.values.freightCharges)) +
      (isNaN(parseFloat(form.values.lenderProcessingFee)) ? 0 : parseFloat(form.values.lenderProcessingFee));
    form.setFieldValue("fees", totalFee);
  }, [
    form.values.licenseFee,
    form.values.registrationFee,
    form.values.titleFee,
    form.values.lienFee,
    form.values.inspectionFee,
    form.values.dealerProcessingFee,
    form.values.dealerProcessingFeeItemized,
    form.values.freightCharges,
    form.values.lenderProcessingFee,
  ]);

  return (
    <SimpleGrid cols={2}>
      <Text size={"sm"} mt={"md"}>
        License Fee
      </Text>
      <TextInput placeholder="License Fee" form={form} validateName="licenseFee" size="xs" />

      <Text size={"sm"} mt={"md"}>
        Registration Fee
      </Text>
      <TextInput placeholder="Registration Fee" form={form} validateName="registrationFee" size="xs" />

      <Text size={"sm"} mt={"md"}>
        Title Fee
      </Text>
      <TextInput placeholder="Title Fee" form={form} validateName="titleFee" size="xs" />

      <Text size={"sm"} mt={"md"}>
        Lien Fee
      </Text>
      <TextInput placeholder="Lien Fee" form={form} validateName="lienFee" size="xs" />

      <Text size={"sm"} mt={"md"}>
        Inspection Fee
      </Text>
      <TextInput placeholder="Inspection Fee" form={form} validateName="inspectionFee" size="xs" />

      <Text size={"sm"} mt={"md"}>
        Dealer Processing Fee
      </Text>
      <TextInput placeholder="Dealer Processing Fee" form={form} validateName="dealerProcessingFee" size="xs" />

      <Text size={"sm"} mt={"md"}>
        Freight Charge
      </Text>
      <TextInput placeholder="Freight Charge" form={form} validateName="freightCharges" size="xs" />

      <Text size={"sm"} mt={"md"}>
        Lender Processing
      </Text>
      <TextInput placeholder="Lender Processing" form={form} validateName="lenderProcessingFee" size="xs" />
    </SimpleGrid>
  );
};

export default FeesDropdown;
